import { BillsMonthType } from '../../../models/Bills.interfaces';
import { billsChartSize } from './constants/bills';
import { t } from 'i18next';
import navigateParams from '../../../utils/navigation/navigateParams';

export const billsCharsOrganize = (data: BillsMonthType[]) => {
    const billsDivided = [];

    for (let i = 0; i < data.length; i += billsChartSize) {
        billsDivided.push(data.slice(i, i + billsChartSize));
    }

    return billsDivided;
};

export const handleDownloadFile = (blob: Blob, name: string, downloadRef: React.RefObject<HTMLAnchorElement>) => {
    if (downloadRef.current) {
        downloadRef.current.id = `${t('bills02')}${name}`;
        downloadRef.current.download = `${t('bills02')}${name}.pdf`;
        downloadRef.current.href = URL.createObjectURL(blob);
        downloadRef.current.click();
    }
};

export const handleParseBlob = (file: string, name: string, downloadRef: React.RefObject<HTMLAnchorElement>) => {
    let blob = new Blob([file], { type: 'application/pdf' });

    handleDownloadFile(blob, name, downloadRef);
};
